import PaymentConfiguration from './Activations/components/PaymentConfiguration';
import * as React from 'react';
import {
    Route,
    Navigate,
    useLocation,
    RouterProvider,
    createBrowserRouter,
    createRoutesFromElements,
} from 'react-router-dom';
import Accounts from './Accounts/components/Accounts';
import CreateAccount from './Accounts/components/CreateAccount';
import EditAccount from './Accounts/components/EditAccount';
import SetPassword from './Accounts/components/SetPassword';
import './App.css';
import AuthProvider from './Authentication/components/AuthProvider';
import Login from './Authentication/components/Login';
import PersistLogin from './Authentication/components/PersistLogin';
import RequireAuth from './Authentication/components/RequireAuth';
import Layout from './Common/components/Layout';
import Activations from './Activations/components/Activations';
import Home from './Home/components/Home';
import CreateActivation from './Activations/components/CreateActivation';
import EditActivation from './Activations/components/EditActivation';
import ActivationDashboard from './Activations/components/ActivationDashboard';
import EditGallery from './GalleryConfiguration/components/EditGallery';
import UploadToActivation from './Activations/components/UploadToActivation';
import Gallery from './Gallery/components/Gallery';
import DeviceKeys from './DeviceManagement/components/DeviceKeys';
import DeviceGroups from './DeviceManagement/components/DeviceGroups';
import CreateDeviceKey from './DeviceManagement/components/CreateDeviceKey';
import ShareManager from './Activations/components/ShareManager';
import UploadTemplate from './EmailTemplates/components/UploadTemplate';
import EmailTemplates from './EmailTemplates/components/Templates';
import GalleryPhoto from './Gallery/components/GalleryPhoto';
import PersonalGallery from './Gallery/components/PersonalGallery';
import ShareLanding from './Share/components/ShareLanding';
import FeatureFlags from './Features/components/FeatureFlags';
import EditFeatureFlag from './Features/components/EditFeatureFlag';
import CreateFeatureFlag from './Features/components/CreateFeatureFlag';
import EditRoleFeatureFlagAssociation from './Features/components/EditRoleFeatureFlagAssociation';
import V3Sync from './Activations/components/V3Sync';
import GalleryDirectory from './Gallery/components/GalleryDirectory';
import EditCrowdGallery from './GalleryConfiguration/components/EditCrowdGallery';
import CreateProcessingFlow from './Processing/components/CreateProcessingFlow';
import EditProcessingFlow from './Processing/components/EditProcessingFlow';
import { DBOfSmiles } from './Gallery/components/dbofsmiles/DBOfSmiles';
import { useEffect } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { FavoritesGallery } from './Gallery/components/favorites/FavoritesGallery';
import SessionGallery from './Gallery/components/SessionGallery';
import SessionSharePage from './Gallery/components/SessionSharePage';
import SessionManager from './Activations/components/SessionManager';
import SharingStation from './Gallery/components/SharingStation';
import Slideshow from './Gallery/components/Slideshow';
import CreateDeviceGroup from './DeviceManagement/components/CreateDeviceGroup';
import CreateDeviceInvite from './DeviceManagement/components/CreateDeviceInvite';
import DeviceInvites from './DeviceManagement/components/DeviceInvites';
import GroupDeviceKeys from './DeviceManagement/components/GroupDeviceKeys';
import JobsDashboard from './Jobs/components/JobsDashboard';
import JobDetail from './Jobs/components/JobDetail';
import JobEditor from './Jobs/components/JobEditor';
import JobGallerySettings from './Jobs/components/JobGallerySettings';
import AdminDocumentFrame from './Documents/components/AdminDocumentFrame';
import PublicFeatureFlags from './Features/components/PublicFeatureFlags';
import 'react-day-picker/dist/style.css';
import CreateJob from './Jobs/components/CreateJob';
import DeviceManagement from './DeviceManagement/components/DeviceManagement';
import OrgSettings from './Orgs/components/OrgSettings';
import PicTimeRedirectHandler from './Orgs/components/PicTimeRedirectHandler';
import { CollageWall } from './Gallery/components/t4agt/CollageWall';
import { AnimatedCollageWall } from './Gallery/components/t4agt/AnimatedCollageWall';
import EditFTPSettings from './GalleryConfiguration/components/EditFTPSettings';
import OrgsList from './Orgs/components/OrgsList';
import OrgCreate from './Orgs/components/OrgCreate';
import OrgAdministration from './Orgs/components/OrgAdministration';
import OrgAccountCreate from './Orgs/components/OrgAccountCreate';
import PageNotFound from './Common/components/PageNotFound';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import persistedStore from '../src/ExperienceBuilder/utils/experienceStore';
import SingleDestinationActivationGallery from './Gallery/components/SingleDestinationActivationGallery';
import Loading from './Common/components/Loading';
import SystemHealth from './SystemHealth/SystemHealth';
import SessionCreate from './Activations/components/SessionCreate';
import PaymentLanding from './Gallery/components/payments/PaymentLandingPage';
import CreateLicenseType from './Licenses/components/CreateLicenseType';
import EditLicenseType from './Licenses/components/EditLicenseType';
import LicenseTypes from './Licenses/components/LicenseTypes';
import EditLicenseTypeFeatures from './Licenses/components/EditLicenseTypeFeatures';
import OrgLicenses from './Licenses/components/OrgLicenses';
import CreateLicense from './Licenses/components/CreateLicense';
import { DeviceTelemetryView } from './DeviceTelemetry';
import { RemoteControlView } from './RemoteControl';
import { REMOTE_CONTROL_PATHS } from './RemoteControl/routes';
import FeatureFlag from './Features/components/FeatureFlag';
import { FeatureFlags as FeatureFlagKeys } from './Features/lib/constants';
import V2Frame from './v2/V2Frame';
import V2AppChrome from './v2/V2AppChrome';
import V2EventChrome from './v2/V2EventChrome';
import V2JobsChrome from './v2/V2JobsChrome';
import JobsV2 from './v2/pages/jobs/JobsV2';
import JobV2 from './v2/pages/jobs/JobV2';
import StaffV2 from './v2/pages/jobs/StaffV2';
import GearV2 from './v2/pages/jobs/GearV2';
import DesignV2 from './v2/pages/jobs/DesignV2';
import VenuesV2 from './v2/pages/jobs/VenuesV2';
import ContactsV2 from './v2/pages/jobs/ContactsV2';
import SettingsV2 from './v2/pages/jobs/SettingsV2';
import InvitePage from './crew/InvitePage';
import CrewFrame from './crew/CrewFrame';
import CrewGigsV2 from './crew/CrewGigsV2';
import CrewProfileV2 from './crew/CrewProfileV2';
import V2Playground from './v2/Playground';
import KitV2 from './v2/pages/KitV2';
import ActivationsV2 from './v2/pages/ActivationsV2';
import HomeV2 from './v2/pages/HomeV2';
import DevicesV2 from './v2/pages/DevicesV2';
import RemoteControlV2 from './v2/pages/RemoteControlV2';
import V2OrgChrome from './v2/V2OrgChrome';
import OrgProfileV2 from './v2/pages/org/OrgProfileV2';
import OrgStatsV2 from './v2/pages/org/OrgStatsV2';
import OrgAccountsV2 from './v2/pages/org/OrgAccountsV2';
import OrgWhitelabelV2 from './v2/pages/org/OrgWhitelabelV2';
import OrgEmailTemplatesV2 from './v2/pages/org/OrgEmailTemplatesV2';
import V2AdminChrome from './v2/V2AdminChrome';
import AdminOrgsV2 from './v2/pages/admin/AdminOrgsV2';
import AdminLicensesV2 from './v2/pages/admin/AdminLicensesV2';
import AdminFeaturesV2 from './v2/pages/admin/AdminFeaturesV2';
import AdminTemplatesV2 from './v2/pages/admin/AdminTemplatesV2';
import AdminGalleryUsersV2 from './v2/pages/admin/AdminGalleryUsersV2';
import AdminAnnouncementsV2 from './v2/pages/admin/AdminAnnouncementsV2';
import AnalyzeV2 from './v2/pages/AnalyzeV2';
import PaymentsV2 from './v2/pages/PaymentsV2';
import ClientReportV2 from './v2/pages/ClientReportV2';
import AdminGlobalSettingsV2 from './v2/pages/admin/AdminGlobalSettingsV2';
import AdminSystemHealthV2 from './v2/pages/admin/AdminSystemHealthV2';
import OverviewV2 from './v2/pages/OverviewV2';
import GalleryV2 from './v2/pages/GalleryV2';
import SharingV2 from './v2/pages/SharingV2';
import SharesListV2 from './v2/pages/SharesListV2';
import InsightsV2 from './v2/pages/InsightsV2';
import WorkflowsV2 from './v2/pages/WorkflowsV2';
import SessionV2 from './v2/pages/SessionV2';
import CaptureV2 from './v2/pages/CaptureV2';
import MediaV2 from './v2/pages/MediaV2';
import ProcessingV2 from './v2/pages/ProcessingV2';
import FlowEditorV2 from './v2/pages/FlowEditorV2';
import LoginV2 from './v2/pages/LoginV2';
import DeepLocal from './Gallery/components/DeepLocal';
import PhotoEngineerStats from './PhotoEngineers/components/PhotoEngineerStats';
import { TemplateList, TemplateForm, TemplateDetail } from './Templates';
import {
    AnnouncementDetail,
    AnnouncementForm,
    AnnouncementList,
} from './Announcements';
import { GlobalSettingsForm } from './GlobalSettings';
import {
    WhitelabelSettings,
    WhitelabelSettingsForm,
    WhitelabelSettingsDetail,
} from './WhitelabelSettings';
import AssignDeviceKey from './DeviceManagement/components/AssignDeviceKey';
import GalleryUserList from './GalleryUsers/GalleryUserList';
import DevToolbar from './v3/DevToolbar';
import V3Swap from './v3/Swap';
import HomeV3 from './v3/pages/HomeV3';
import ActivationsV3 from './v3/pages/ActivationsV3';
import OverviewV3 from './v3/pages/OverviewV3';
import V3Only, { V3Redirect, WorldPick } from './v3/chrome/V3Only';
import ActivationFormV3 from './v3/pages/ActivationFormV3';
import DesignV3 from './v3/pages/DesignV3';
import JobsSettingsV3 from './v3/pages/JobsSettingsV3';
import SharesV3 from './v3/pages/SharesV3';
import AnalyzeV3 from './v3/pages/AnalyzeV3';
import PaymentsV3 from './v3/pages/PaymentsV3';
import DeviceKeyCreateV3 from './v3/pages/devices/DeviceKeyCreateV3';
import DeviceGroupCreateV3 from './v3/pages/devices/DeviceGroupCreateV3';
import DeviceGroupKeysV3 from './v3/pages/devices/DeviceGroupKeysV3';
import DeviceInvitesV3 from './v3/pages/devices/DeviceInvitesV3';
import DeviceInviteCreateV3 from './v3/pages/devices/DeviceInviteCreateV3';
import DeviceTelemetryV3 from './v3/pages/devices/DeviceTelemetryV3';
import OrgProfileV3 from './v3/pages/org/OrgProfileV3';
import CaptureV3 from './v3/pages/event/CaptureV3';
import ProcessingV3 from './v3/pages/event/ProcessingV3';
import FlowEditorV3 from './v3/pages/event/FlowEditorV3';
import DeliveryV3 from './v3/pages/event/DeliveryV3';
import GalleryV3 from './v3/pages/event/GalleryV3';
import InsightsV3 from './v3/pages/event/InsightsV3';
import SessionV3 from './v3/pages/event/SessionV3';
import ProductionV3 from './v3/pages/event/ProductionV3';
import MediaV3 from './v3/pages/event/MediaV3';
import OrgStatsV3 from './v3/pages/org/OrgStatsV3';
import OrgAccountsV3 from './v3/pages/org/OrgAccountsV3';
import OrgWhitelabelV3 from './v3/pages/org/OrgWhitelabelV3';
import OrgTemplatesV3 from './v3/pages/org/OrgTemplatesV3';
import OrgIntegrationsV3 from './v3/pages/org/OrgIntegrationsV3';
import AdminOrgsV3 from './v3/pages/admin/AdminOrgsV3';
import AdminOrgDetailV3 from './v3/pages/admin/AdminOrgDetailV3';
import AdminLicensesV3 from './v3/pages/admin/AdminLicensesV3';
import AdminFeaturesV3 from './v3/pages/admin/AdminFeaturesV3';
import AdminTemplatesV3 from './v3/pages/admin/AdminTemplatesV3';
import AdminAnnouncementsV3 from './v3/pages/admin/AdminAnnouncementsV3';
import AdminGalleryUsersV3 from './v3/pages/admin/AdminGalleryUsersV3';
import AdminGlobalSettingsV3 from './v3/pages/admin/AdminGlobalSettingsV3';
import AdminSystemHealthV3 from './v3/pages/admin/AdminSystemHealthV3';
import AdminStatsV3 from './v3/pages/admin/AdminStatsV3';
import AdminSyncV3 from './v3/pages/admin/AdminSyncV3';
import SharingV3, {
    ShareMethodsRedirect,
} from './v3/pages/SharingV3';
import KitV3 from './v3/pages/KitV3';
import RulesV3 from './v3/pages/RulesV3';
import PipelineV3 from './v3/pages/PipelineV3';
import JobV3 from './v3/pages/JobV3';
import PreviewV3 from './v3/pages/PreviewV3';
import StaffV3 from './v3/pages/StaffV3';
import GearV3 from './v3/pages/GearV3';
import VenuesV3 from './v3/pages/VenuesV3';
import ContactsV3 from './v3/pages/ContactsV3';

const GalleryExperienceEditor = React.lazy(
    () => import('./GalleryExperienceEditor/GalleryExperienceEditor'),
);

let { store, persistor } = persistedStore();

const ROLES = {
    Admin: 0,
    User: 1,
    Client: 2,
    Contractor: 3,
    GlobalAdmin: 69,
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            {/* @ts-ignore */}
            <Route element={<PublicFeatureFlags />}>
                <Route path="/gallery" element={<GalleryDirectory />} />
                <Route path="/db-of-smiles" element={<DBOfSmiles />} />
                <Route
                    path="/collage/:activationId"
                    element={<CollageWall />}
                />
                <Route
                    path="/animated-collage/:activationId"
                    element={<AnimatedCollageWall />}
                />
                <Route path="/gallery/:slug" element={<Gallery />} />
                <Route
                    path="/gallery/:slug/user/:destinationSlug"
                    element={<SingleDestinationActivationGallery />}
                />
                <Route
                    path="/gallery/:slug/sharing"
                    element={<SharingStation />}
                />
                <Route path="/gallery/:slug/dl" element={<DeepLocal />} />
                <Route
                    path="/gallery/:slug/session-payment/:token"
                    element={<PaymentLanding />}
                />
                <Route
                    path="/gallery/:slug/slideshow"
                    element={<Slideshow />}
                />
                <Route
                    path="/session/:galleryId/:photoSessionId"
                    element={<SessionGallery />}
                />
                <Route
                    path="/session/:galleryId/:photoSessionId/share"
                    element={<SessionSharePage />}
                />
                <Route path="/photos/:slug" element={<PersonalGallery />} />
                <Route path="/photo/:galleryId" element={<GalleryPhoto />} />
                <Route
                    path="/gallery/:galleryId/share"
                    element={<ShareLanding />}
                />
                <Route path="/login" element={<Login />} />
                <Route path="/v2/login" element={<LoginV2 />} />
                <Route path="/invite/:token" element={<InvitePage />} />
                {/* client report magic link — unauthenticated */}
                <Route
                    path="/report/:token"
                    element={<ClientReportV2 />}
                />
            </Route>
            <Route element={<PersistLogin />}>
                {/* crew portal — contractor role gate lives in CrewFrame,
                    outside the dashboard's RequireAuth roles */}
                <Route path="/crew" element={<CrewFrame />}>
                    <Route index element={<CrewGigsV2 />} />
                    <Route path="profile" element={<CrewProfileV2 />} />
                </Route>
                <Route
                    element={
                        <RequireAuth
                            allowedRoles={[
                                ROLES.Admin,
                                ROLES.User,
                                ROLES.GlobalAdmin,
                            ]}
                        />
                    }
                >
                    <Route
                        element={<RequireAuth allowedRoles={[ROLES.Admin, ROLES.GlobalAdmin]} />}
                    >
                        <Route
                            path="gallery-experiences/organization-defaults/:orgId"
                            element={
                                <React.Suspense fallback={<div>Opening gallery designer…</div>}>
                                    <GalleryExperienceEditor />
                                </React.Suspense>
                            }
                        />
                        <Route
                            path="gallery-experiences/:activationId/:galleryId"
                            element={
                                <React.Suspense fallback={<div>Opening gallery designer…</div>}>
                                    <GalleryExperienceEditor />
                                </React.Suspense>
                            }
                        />
                    </Route>
                    <Route path="/" element={<Layout />}>
                        <Route path="kit" element={<KitV3 />} />
                        <Route path="rules" element={<RulesV3 />} />
                        <Route path="preview" element={<PreviewV3 />} />
                        <Route path="staff" element={<StaffV3 />} />
                        <Route path="gear" element={<GearV3 />} />
                        <Route path="venues" element={<VenuesV3 />} />
                        <Route path="contacts" element={<ContactsV3 />} />
                        <Route path="pipeline" element={<PipelineV3 />} />
                        <Route
                            path="pipeline/settings"
                            element={<V3Only fallback="/v2/jobs/settings"><JobsSettingsV3 /></V3Only>}
                        />
                        <Route path="pipeline/:jobId" element={<JobV3 />} />
                        <Route
                            path="design"
                            element={<V3Only fallback="/v2/jobs/design"><DesignV3 /></V3Only>}
                        />
                        <Route
                            path="home"
                            element={
                                <V3Swap
                                    classic={<Home />}
                                    v3={<HomeV3 />}
                                />
                            }
                        />

                        <Route path="accounts" element={<V3Redirect to="/org/accounts"><Accounts /></V3Redirect>} />
                        <Route
                            path="favorites"
                            element={<FavoritesGallery />}
                        />
                        <Route path="accounts/:id" element={<V3Redirect to="/org/accounts"><EditAccount /></V3Redirect>} />
                        <Route
                            path="accounts/:id/password"
                            element={<V3Redirect to="/org/accounts"><SetPassword /></V3Redirect>}
                        />
                        <Route
                            path="accounts/create"
                            element={<V3Redirect to="/org/accounts"><CreateAccount /></V3Redirect>}
                        />
                        <Route
                            path="activations"
                            element={
                                <V3Swap
                                    classic={<Activations />}
                                    v3={<ActivationsV3 />}
                                />
                            }
                        />
                        <Route
                            path="activations/create"
                            element={<WorldPick classic={<CreateActivation />} v3={<ActivationFormV3 />} />}
                        />

                        <Route path="activations/v3sync" element={<V3Redirect to="/admin/sync"><V3Sync /></V3Redirect>} />

                        <Route
                            path="activations/:id/edit"
                            element={<WorldPick classic={<EditActivation />} v3={<ActivationFormV3 />} />}
                        />

                        <Route
                            path="activations/:activationId"
                            element={
                                <V3Swap
                                    classic={<ActivationDashboard />}
                                    v3={<OverviewV3 />}
                                />
                            }
                        />
                        <Route
                            path="activations/:activationId/processing"
                            element={<V3Only fallback="/v2/activations/:activationId/processing"><ProcessingV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/processing/new"
                            element={<V3Only fallback="/v2/activations/:activationId/processing/new"><FlowEditorV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/processing/:flowId/edit"
                            element={<V3Only fallback="/v2/activations/:activationId/processing/:flowId/edit"><FlowEditorV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/capture"
                            element={<V3Only fallback="/v2/activations/:activationId/capture"><CaptureV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/production"
                            element={<V3Only fallback="/v2/activations/:activationId"><ProductionV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/media"
                            element={<V3Only fallback="/v2/activations/:activationId/media"><MediaV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/gallery"
                            element={<V3Only fallback="/v2/activations/:activationId/gallery"><GalleryV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/insights"
                            element={<V3Only fallback="/v2/activations/:activationId/insights"><InsightsV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/insights/session/:photoSessionId"
                            element={<V3Only fallback="/v2/activations/:activationId/insights/session/:photoSessionId"><SessionV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/delivery"
                            element={<V3Only fallback="/v2/activations/:activationId/sharing"><DeliveryV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/shares"
                            element={<V3Only fallback="/v2/activations/:activationId/sharing/shares"><SharesV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/analyze"
                            element={<V3Only fallback="/v2/activations/:activationId/analyze"><AnalyzeV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/payments"
                            element={<V3Only fallback="/v2/activations/:activationId/payments"><PaymentsV3 /></V3Only>}
                        />
                        <Route
                            path="activations/:activationId/sharing"
                            element={<SharingV3 />}
                        />
                        <Route
                            path="activations/:activationId/sharing/methods"
                            element={<ShareMethodsRedirect />}
                        />

                        <Route
                            path="activations/:id/upload"
                            element={<UploadToActivation />}
                        />

                        <Route
                            path="activations/:id/gallery/:galleryId/edit"
                            element={<V3Redirect to="/v2/activations/:id/gallery"><EditGallery /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/sessions/create"
                            element={<V3Redirect to="/activations/:activationId/insights/session/new"><SessionCreate /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/sessions/:photoSessionId"
                            element={<V3Redirect to="/activations/:activationId/insights/session/:photoSessionId"><SessionManager /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/manage-shares"
                            element={<V3Redirect to="/activations/:activationId/shares"><ShareManager /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/galleryConfiguration/:galleryId"
                            element={<V3Redirect to="/activations/:activationId/gallery"><EditGallery /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/gallery/:galleryId/edit/crowdGallery"
                            element={<V3Redirect to="/activations/:activationId/gallery"><EditCrowdGallery /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/gallery/:galleryId/edit/ftp"
                            element={<V3Redirect to="/activations/:activationId/gallery"><EditFTPSettings /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/gallery/:galleryId/processing/create"
                            element={<V3Redirect to="/activations/:activationId/processing/new"><CreateProcessingFlow /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/gallery/:galleryId/processing/edit/:flowId"
                            element={<V3Redirect to="/activations/:activationId/processing/:flowId/edit"><EditProcessingFlow /></V3Redirect>}
                        />

                        <Route
                            path="activations/:activationId/documents/:documentId"
                            element={<AdminDocumentFrame />}
                        />

                        <Route
                            path="device-management/device-groups"
                            element={<V3Redirect to="/device-management#groups"><DeviceGroups /></V3Redirect>}
                        />

                        <Route
                            path="device-management/device-groups/create"
                            element={<WorldPick classic={<CreateDeviceGroup />} v3={<DeviceGroupCreateV3 />} />}
                        />

                        <Route
                            path="device-management/device-groups/:groupId/invites"
                            element={<WorldPick classic={<DeviceInvites />} v3={<DeviceInvitesV3 />} />}
                        />

                        <Route
                            path="device-management/device-invites/create"
                            element={<WorldPick classic={<CreateDeviceInvite />} v3={<DeviceInviteCreateV3 />} />}
                        />

                        <Route
                            path="device-management"
                            element={<DeviceManagement />}
                        />
                        <Route path="device-keys" element={<V3Redirect to="/device-management#keys"><DeviceKeys /></V3Redirect>} />

                        <Route
                            path="device-management/device-groups/:groupId/device-keys"
                            element={<WorldPick classic={<GroupDeviceKeys />} v3={<DeviceGroupKeysV3 />} />}
                        />

                        <Route
                            path="device-management/device-groups/:groupId/device-keys/assign"
                            element={<WorldPick classic={<AssignDeviceKey />} v3={<DeviceGroupKeysV3 />} />}
                        />

                        <Route
                            path="device-management/device-groups/:groupId/device-keys/create"
                            element={<WorldPick classic={<CreateDeviceKey />} v3={<DeviceKeyCreateV3 />} />}
                        />

                        <Route
                            path="device-management/device-keys/create"
                            element={<WorldPick classic={<CreateDeviceKey />} v3={<DeviceKeyCreateV3 />} />}
                        />

                        <Route path="/templates" element={<V3Redirect to="/org/templates"><EmailTemplates /></V3Redirect>} />

                        <Route
                            path="templates/import"
                            element={<V3Redirect to="/org/templates"><UploadTemplate /></V3Redirect>}
                        />

                        <Route
                            path="org/whitelabel-settings"
                            element={<V3Redirect to="/org/whitelabel"><WhitelabelSettings /></V3Redirect>}
                        />

                        <Route
                            path="org/whitelabel-settings/new"
                            element={<V3Redirect to="/org/whitelabel"><WhitelabelSettingsForm /></V3Redirect>}
                        />

                        <Route
                            path="org/whitelabel-settings/:id"
                            element={<V3Redirect to="/org/whitelabel"><WhitelabelSettingsDetail /></V3Redirect>}
                        />

                        <Route
                            path="org/whitelabel-settings/:id/edit"
                            element={<V3Redirect to="/org/whitelabel"><WhitelabelSettingsForm /></V3Redirect>}
                        />

                        <Route path="admin" element={<V3Only fallback="/admin/orgs"><AdminOrgsV3 /></V3Only>} />

                        <Route path="admin/stats" element={<V3Only fallback="/admin/photo-engineers/stats"><AdminStatsV3 /></V3Only>} />

                        <Route path="admin/sync" element={<V3Only fallback="/activations/v3sync"><AdminSyncV3 /></V3Only>} />

                        <Route
                            path="admin/templates"
                            element={<WorldPick classic={<TemplateList />} v3={<AdminTemplatesV3 />} />}
                        />

                        <Route
                            path="admin/templates/new"
                            element={<V3Redirect to="/admin/templates"><TemplateForm /></V3Redirect>}
                        />

                        <Route
                            path="admin/templates/:id"
                            element={<V3Redirect to="/admin/templates"><TemplateDetail /></V3Redirect>}
                        />

                        <Route
                            path="admin/templates/:id/edit"
                            element={<V3Redirect to="/admin/templates"><TemplateForm /></V3Redirect>}
                        />

                        <Route
                            path="admin/features"
                            element={<WorldPick classic={<FeatureFlags />} v3={<AdminFeaturesV3 />} />}
                        />

                        <Route
                            path="admin/features/create"
                            element={<V3Redirect to="/admin/features"><CreateFeatureFlag /></V3Redirect>}
                        />

                        <Route
                            path="admin/features/:id"
                            element={<V3Redirect to="/admin/features"><EditFeatureFlag /></V3Redirect>}
                        />

                        <Route
                            path="admin/features/role/:name/:id"
                            element={<V3Redirect to="/admin/features"><EditRoleFeatureFlagAssociation /></V3Redirect>}
                        />

                        <Route
                            path="admin/licenses"
                            element={<WorldPick classic={<LicenseTypes />} v3={<AdminLicensesV3 />} />}
                        />

                        <Route
                            path="admin/licenses/create"
                            element={<V3Redirect to="/admin/licenses"><CreateLicenseType /></V3Redirect>}
                        />

                        <Route
                            path="admin/licenses/:id"
                            element={<V3Redirect to="/admin/licenses"><EditLicenseType /></V3Redirect>}
                        />

                        <Route
                            path="admin/licenses/:licenseTypeId/features"
                            element={<V3Redirect to="/admin/licenses"><EditLicenseTypeFeatures /></V3Redirect>}
                        />

                        <Route
                            path="admin/licenses/org/:orgId"
                            element={<V3Redirect to="/admin/licenses?org=:orgId"><OrgLicenses /></V3Redirect>}
                        />

                        <Route
                            path="admin/licenses/create-license"
                            element={<V3Redirect to="/admin/licenses"><CreateLicense /></V3Redirect>}
                        />

                        <Route path="admin/orgs" element={<V3Redirect to="/admin"><OrgsList /></V3Redirect>} />

                        <Route
                            path="admin/orgs/:orgId"
                            element={<WorldPick classic={<OrgAdministration />} v3={<AdminOrgDetailV3 />} />}
                        />

                        <Route
                            path="admin/orgs/create"
                            element={<V3Redirect to="/admin"><OrgCreate /></V3Redirect>}
                        />

                        <Route
                            path="admin/orgs/:orgId/account/create"
                            element={<V3Redirect to="/admin/orgs/:orgId"><OrgAccountCreate /></V3Redirect>}
                        />

                        <Route
                            path="admin/system-health"
                            element={<WorldPick classic={<SystemHealth />} v3={<AdminSystemHealthV3 />} />}
                        />

                        <Route
                            path="admin/photo-engineers/stats"
                            element={<V3Redirect to="/admin/stats"><PhotoEngineerStats /></V3Redirect>}
                        />

                        <Route
                            path="admin/announcements"
                            element={<WorldPick classic={<AnnouncementList />} v3={<AdminAnnouncementsV3 />} />}
                        />

                        <Route
                            path="admin/announcements/new"
                            element={<V3Redirect to="/admin/announcements"><AnnouncementForm /></V3Redirect>}
                        />

                        <Route
                            path="admin/announcements/:id"
                            element={<V3Redirect to="/admin/announcements"><AnnouncementDetail /></V3Redirect>}
                        />

                        <Route
                            path="admin/announcements/:id/edit"
                            element={<V3Redirect to="/admin/announcements"><AnnouncementForm /></V3Redirect>}
                        />

                        <Route
                            path="admin/global-settings"
                            element={<WorldPick classic={<GlobalSettingsForm />} v3={<AdminGlobalSettingsV3 />} />}
                        />

                        <Route path="jobs" element={<V3Redirect to="/pipeline"><JobsDashboard /></V3Redirect>} />

                        <Route path="jobs/:id" element={<JobDetail />} />
                        <Route path="jobs/:id/edit" element={<JobEditor />} />
                        <Route
                            path="jobs/:jobId/gallery/:galleryId/edit"
                            element={<JobGallerySettings />}
                        />

                        <Route
                            path="admin/gallery-users"
                            element={<WorldPick classic={<GalleryUserList />} v3={<AdminGalleryUsersV3 />} />}
                        />

                        <Route path="jobs/create" element={<CreateJob />} />

                        <Route
                            path="jobs/:jobId/activation/create"
                            element={<WorldPick classic={<CreateActivation />} v3={<ActivationFormV3 />} />}
                        />

                        <Route path="org" element={<WorldPick classic={<OrgSettings />} v3={<OrgProfileV3 />} />} />
                        <Route path="org/stats" element={<V3Only fallback="/v2/org/stats"><OrgStatsV3 /></V3Only>} />
                        <Route path="org/accounts" element={<V3Only fallback="/accounts"><OrgAccountsV3 /></V3Only>} />
                        <Route path="org/whitelabel" element={<V3Only fallback="/org/whitelabel-settings"><OrgWhitelabelV3 /></V3Only>} />
                        <Route path="org/templates" element={<V3Only fallback="/templates"><OrgTemplatesV3 /></V3Only>} />
                        <Route path="org/integrations" element={<V3Only fallback="/org"><OrgIntegrationsV3 /></V3Only>} />

                        <Route
                            path="integrations/pic-time/redirect"
                            element={<PicTimeRedirectHandler />}
                        />

                        <Route
                            path="/orgs/:orgId/device-telemetry/:deviceId"
                            element={<WorldPick classic={<DeviceTelemetryView />} v3={<DeviceTelemetryV3 />} />}
                        />

                        <Route
                            path={REMOTE_CONTROL_PATHS.v1}
                            element={
                                <FeatureFlag
                                    flag={FeatureFlagKeys.REMOTE_CONTROL_V1}
                                    fallback={() => (
                                        <Navigate to="/home" />
                                    )}
                                >
                                    <RemoteControlView />
                                </FeatureFlag>
                            }
                        />

                        <Route path="/" element={<Navigate to="/home" />} />
                    </Route>

                    {/* v2 design-system preview — full-page, outside the old
                        Layout chrome. Gated by GLOBAL_ADMIN_V1 for now; moves
                        to a dedicated WEB_V2 flag at rollout. */}
                    <Route path="/v2" element={<V2Frame />}>
                        <Route element={<V2AppChrome />}>
                            <Route index element={<HomeV2 />} />
                            <Route
                                path="playground"
                                element={<V2Playground />}
                            />
                            <Route path="kit" element={<KitV2 />} />
                            <Route
                                path="activations"
                                element={<ActivationsV2 />}
                            />
                            <Route
                                path="devices"
                                element={<DevicesV2 />}
                            />
                            <Route
                                path={REMOTE_CONTROL_PATHS.v2}
                                element={<RemoteControlV2 />}
                            />
                        </Route>
                        {/* org settings (ADMIN-MERGE Phase A) —
                            chrome route-guards to Admin/GlobalAdmin */}
                        <Route element={<V2OrgChrome />}>
                            <Route path="org" element={<OrgProfileV2 />} />
                            <Route path="org/payments" element={<PaymentConfiguration />} />
                            <Route
                                path="org/stats"
                                element={<OrgStatsV2 />}
                            />
                            <Route
                                path="org/accounts"
                                element={<OrgAccountsV2 />}
                            />
                            <Route
                                path="org/whitelabel"
                                element={<OrgWhitelabelV2 />}
                            />
                            <Route
                                path="org/templates"
                                element={<OrgEmailTemplatesV2 />}
                            />
                        </Route>
                        {/* platform admin (ADMIN-MERGE Phase B) —
                            chrome route-guards to GlobalAdmin */}
                        <Route element={<V2AdminChrome />}>
                            <Route
                                path="admin"
                                element={<AdminOrgsV2 />}
                            />
                            <Route
                                path="admin/licenses"
                                element={<AdminLicensesV2 />}
                            />
                            <Route
                                path="admin/features"
                                element={<AdminFeaturesV2 />}
                            />
                            <Route
                                path="admin/templates"
                                element={<AdminTemplatesV2 />}
                            />
                            <Route
                                path="admin/gallery-users"
                                element={<AdminGalleryUsersV2 />}
                            />
                            <Route
                                path="admin/announcements"
                                element={<AdminAnnouncementsV2 />}
                            />
                            <Route
                                path="admin/global-settings"
                                element={<AdminGlobalSettingsV2 />}
                            />
                            <Route
                                path="admin/system-health"
                                element={<AdminSystemHealthV2 />}
                            />
                        </Route>
                        <Route element={<V2JobsChrome />}>
                            <Route path="jobs" element={<JobsV2 />} />
                            <Route path="jobs/:jobId" element={<JobV2 />} />
                            <Route path="jobs/staff" element={<StaffV2 />} />
                            <Route path="jobs/gear" element={<GearV2 />} />
                            <Route
                                path="jobs/design"
                                element={<DesignV2 />}
                            />
                            <Route
                                path="jobs/venues"
                                element={<VenuesV2 />}
                            />
                            <Route
                                path="jobs/contacts"
                                element={<ContactsV2 />}
                            />
                            <Route
                                path="jobs/settings"
                                element={<SettingsV2 />}
                            />
                        </Route>
                        {/* pre-rename bookmarks */}
                        <Route
                            path="production/*"
                            element={<Navigate to="/v2/jobs" replace />}
                        />
                        <Route
                            path="activations/:activationId"
                            element={<V2EventChrome />}
                        >
                            <Route index element={<OverviewV2 />} />
                            <Route
                                path="production"
                                element={<Navigate to=".." replace />}
                            />
                            <Route path="gallery" element={<GalleryV2 />} />
                            <Route path="sharing" element={<SharingV2 />} />
                            <Route
                                path="sharing/shares"
                                element={<SharesListV2 />}
                            />
                            <Route
                                path="insights"
                                element={<InsightsV2 />}
                            />
                            <Route
                                path="insights/session/new"
                                element={<SessionV2 />}
                            />
                            <Route
                                path="insights/session/:photoSessionId"
                                element={<SessionV2 />}
                            />
                            <Route
                                path="workflows"
                                element={<WorkflowsV2 />}
                            />
                            <Route path="capture" element={<CaptureV2 />} />
                            <Route path="media" element={<MediaV2 />} />
                            <Route
                                path="analyze"
                                element={<AnalyzeV2 />}
                            />
                            <Route
                                path="payments"
                                element={<PaymentsV2 />}
                            />
                            <Route
                                path="processing"
                                element={<ProcessingV2 />}
                            />
                            <Route
                                path="processing/new"
                                element={<FlowEditorV2 />}
                            />
                            <Route
                                path="processing/:flowId/edit"
                                element={<FlowEditorV2 />}
                            />
                        </Route>
                    </Route>
                </Route>
                <Route path="/" element={<Navigate to="/home" />} />

                <Route path="*" element={<PageNotFound />} />
            </Route>
        </>,
    ),
);

export default function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <AuthProvider>
                    <RouterProvider
                        router={router}
                        fallbackElement={<Loading isLoading={true} />}
                    />
                    <DevToolbar />
                    <div className="App"></div>
                </AuthProvider>
            </PersistGate>
        </Provider>
    );
}

// eslint-disable-next-line
function FirebaseAnalytics() {
    const location = useLocation();
    useEffect(() => {
        const page_path = location.pathname + location.search;
        const analytics = getAnalytics();
        logEvent(analytics, 'page_view', { firebase_screen: page_path });
    }, [location]);
    return null;
}
